// EN escapeHtml för hela kart-stacken (säkerhetsgranskning S-094, 2026-09-24).
// Escapar & < > " ' så att strängen är säker både som text och i ett
// attribut oavsett citattecken. null/undefined ⇒ ''.
// Skriv ALDRIG en lokal `function esc(` i js/karta-v2: importera den här
// (`import { escapeHtml as esc } from '../util/escape.js'`).
// scripts/check_esc_helpers.py (selfcheck --fast + deploy-gaten) fäller nya kopior.

export function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));
}
